import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';

import { map, take } from 'rxjs/operators';
import { Observable, of, Subscription } from '../../../../node_modules/rxjs';
import { ISubjectSettingList, SubjectSetting } from '../models/subject-setting';
import { SubjectType } from '../models/subject-type';
import { BaseRestService } from './base-rest.service';
import { SubjectTypeService } from './subject-type.service';

@Injectable({ providedIn: 'root'})
export class SubjectSettingService extends BaseRestService<SubjectSetting, ISubjectSettingList> implements OnDestroy{

  private onSubjectTypeChanged$: Subscription;
  
  constructor(http: HttpClient, private subjectTypeService: SubjectTypeService, protected router: Router) {
    super(SubjectSettingService, http, 'api/subjectsettings', 'subjectsettings', router);

    // enable caching
    this.cacheEnabled = true;

    this.onSubjectTypeChanged$ = this.subjectTypeService.onItemChanged.subscribe((_) => {
      this.clearCache();
    });
  }

  ngOnDestroy(){
    this.onSubjectTypeChanged$.unsubscribe();
  }

  getAll() {
    this.subjectTypeService.getAllData().pipe(take(1)).subscribe((subjectType) => {
      super.getAll();
    });
  }

  // getBySubjectTypeName(subjectTypeName: string): Observable<SubjectSetting>{
  //   return this.getAllData().pipe(take(1), map((settings) => {
  //     return settings.find((x) => x.subjectType.name.toLowerCase() === subjectTypeName.toLowerCase());
  //   }));
  // }

  getBySubjectTypeId(subjectTypeId: number): Observable<SubjectSetting>{
    return this.getAllData().pipe(take(1), map((settings) => {
      return settings.find((x) => x.subjectType.id === subjectTypeId);
    }));
  }

  hydrate(item: SubjectSetting): Observable<SubjectSetting> {
    if ((!item.subjectType) || (item.subjectType.id !== item.subjectTypeId)){
      return this.subjectTypeService.getById(item.subjectTypeId).pipe(map((subjectType) => {
        item.subjectType = new SubjectType(subjectType);
        return item;
      }));
    }
    else{
      return of(item);
    }
  }
}
